var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pieEchartPage",staticClass:"pieEchartPage"},[_c('div',{attrs:{"id":_vm.pieData.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }